import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemaService {

  private darkTheme = new BehaviorSubject<boolean>(
    localStorage.getItem('theme') === 'dark-theme'
  );
  valDarkTheme = this.darkTheme.asObservable();

  constructor() {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'theme') {
        this.darkTheme.next(event.newValue === 'dark-theme');
      }
    });
  }

  toggleTheme(value: boolean) {
    localStorage.setItem('theme', value ? 'dark-theme' : 'light-theme');
    this.darkTheme.next(value);
  }

}
